import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectIsRoleFlow } from '../../redux/skillSlice'

const ProgressBar = ({ currentStep, totalSteps = 5, stepText }) => {
    const progressPercentage = (currentStep / totalSteps) * 100
    const isRoleFlow = useSelector(selectIsRoleFlow);



    return (


        <div className='flex gap-4 h-3 items-center w-full'>
            <div className='flex items-center justify-center gap-1'>
            {
  Array.from({ length: totalSteps }).map((_, index) => (
    index < currentStep ? (
      <div
        key={index}
        className={`${isRoleFlow ? 'h-3 w-3' : 'h-3 w-3'} bg-[#54B226] p-[2px] rounded-full flex items-center justify-center`}
      >
        <FontAwesomeIcon
          icon={faCheck}
          className="text-white w-full h-full"
        />
      </div>
    ) : (
      <div key={index} className={`${isRoleFlow ? 'w-[8px] h-[1px]' : 'w-[12px] h-[1px]'} ${index === currentStep ? 'bg-white' : 'bg-white/30'}`} />
    )
  ))
}
                {/* <div 
                    className='absolute inset-y-0 left-0 bg-[#7FC241] rounded-full transition-all duration-300'
                    style={{ width: `${progressPercentage}%` }}
                ></div> */}
            </div>
            <div className='flex flex-col font-semibold justify-center text-[12px] text-[#70AEFF]/50 tracking-wider'>
                <p>{stepText}</p>
            </div>
        </div>
    )
}

export default ProgressBar